<template>
	<div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-size-65">
				<form ref="edit_demand_form" @submit.prevent="addDemand">
					<md-card>
						<md-card-header class="md-card-header-icon md-card-header-blue">
							<div class="md-layout">
								<div class="md-layout-item">
									<div class="card-icon">
										<font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
									</div>
									<h4 class="title">Ajout d'une demande</h4>
								</div>
							</div>
						</md-card-header>
						<demand-form :demand="demand" :errors="errors" @loaded="loading = false" @selected="(e) => this.linkedDemands = e"></demand-form>
						<md-card-actions md-alignment="left">
							<md-button type="submit" class="md-success">
								Enregistrer
							</md-button>
							<md-button class="md-warning" @click="goBack">
								Retour
							</md-button>
						</md-card-actions>
					</md-card>
				</form>
			</div>
			<div class="md-layout-item md-size-35">
				<demand-linked :demand="demand" :linkedDemands="linkedDemands"></demand-linked>
			</div>
		</div>
		<div class="loading-overlay" :class="loading ? 'opacity-100 fixed z-50 w-full h-full' : 'opacity-0 absolute z-0 w-0 h-0'">
			<div class="h-full w-full flex items-center justify-center">
				<md-progress-spinner class="md-white" md-mode="indeterminate"
				                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
			</div>
		</div>
	</div>
</template>


<script>
import DemandForm from "@/pages/Demands/components/DemandForm";
import DemandLinked from "@/pages/Demands/components/DemandLinked";

export default {
    name: "DemandAdd",
    components: {
        DemandForm, DemandLinked
    },
    data() {
        return {
            linkedDemands: [],
            demand: {
                date: this.$moment(new Date()).format(),
                client: null,
                site: null,
                prospect: null,
                demand_types: [],
                subject: null,
                message: null,
            },
            errors: [],
	        loading: true,
        }
    },
    methods: {
        async addDemand() {
            this.errors = []
            if(this.demand.prospect !== null || this.demand.client) {
                try {
                    const { data } = await this.$store.dispatch('demands/addDemand', {
                        date: this.$moment(this.demand.date).format('YYYY-MM-DD HH:mm:ss'),
                        client_id: this.demand.client?.id ?? null,
                        site_id: this.demand.site?.id ?? null,
                        prospect: this.demand.prospect,
                        types: this.demand.demand_types,
                        subject: this.demand.subject,
                        message: this.demand.message
                    })
                    await this.$store.dispatch('alerts/success', 'Demande ajoutée')
                    await this.$router.push({ name: 'Demand Details',params: { demandId: data.id } })
                } catch (e) {
                    this.errors = e.response.data.errors
                }
            } else {
                await this.$store.dispatch('alerts/warning', 'Le choix d\'un client ou l\'ajout d\'un prospect est obligatoire')
            }
        },
        goBack() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>

</style>
